(function() {
  function addTracking(el) {
    if ($(el).length) {
      let isTracked = false;
      const observer = new IntersectionObserver(onIntersection, {
        root: null,
        threshold: .2
      })
      
      function onIntersection(entries, opts){
        entries.forEach(entry => {
          if (!isTracked && entry.isIntersecting) {
            const tracking = $(entry.target).data('tracking');

            gtag("event", "landing_page_best_seller", {
              section: tracking
            });
            
            isTracked = true;
          }
        })
      }
      
      // Use the observer to observe an element
      observer.observe($(el).get(0))
    }
  }
  
  function tabControl() {
    var tabs = $('.tabs');
    
    tabs.find('a').on('click', function(event) {
      event.preventDefault();
      
      var target = $(this).attr('href'),
          tabs = $(this).closest('.tabs'),
          buttons = tabs.find('a'),
          item = tabs.closest('.container').find('.tab-content-wrapper');
      
      buttons.removeClass('active');
      item.removeClass('active');
      $(this).addClass('active');
      $(target).addClass('active');
    });
  }

  function initCarousel(el) {
   const emblaNode = document.querySelector(el);
  
    const prevButtonNode = emblaNode.querySelector('.embla__prev');
    const nextButtonNode = emblaNode.querySelector('.embla__next');
    
    const options = { 
      dragFree: true,
      loop: false,
      slidesToScroll: 1,
    };
    const emblaApi = EmblaCarousel(emblaNode, options);
    if (prevButtonNode) prevButtonNode.addEventListener('click', emblaApi.scrollPrev, false);
    if (nextButtonNode) nextButtonNode.addEventListener('click', emblaApi.scrollNext, false);
  }

  $(function() {
    tabControl();
    
    initCarousel(".tabs.has-thumbnail");
    initCarousel(".tabs-carousel-wrapper");

    const windowWidth = $(window).width();
    if (windowWidth < 768) {
      $('.selling-point-wrapper').slick({
        "dots": true,
        "mobileFirst": true,
        "draggable": true,
        "arrows": false,
        "autoplay": false,
        "touchThreshold": 10,
        "infinite": true,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        useTransform: false
      });
    }

    addTracking('.bs__collection.flash-sale');
    addTracking('.bs__collection.with-thumbnail');
    addTracking('.bs__collection.only-text');
  })
})();